function openPopup(portalId, formId) {

  const formTarget = document.getElementById('hubspot-form-target');

  if (formTarget) {
    formTarget.innerHTML = '';
  }

  if (portalId && formId && window.hbspt) {
    
    hbspt.forms.create({
      region: "na1", 
      portalId: portalId,
      formId: formId,
      target: '#hubspot-form-target'
    });

  } else {

    if (formTarget) {
      formTarget.innerHTML = 'Error: Form could not be loaded.';
    }
    console.error('HubSpot form IDs or hbspt object not found.');
  }

  document.getElementById('form-popup').style.display = 'block';
  document.body.style.overflow = 'hidden';
}
  

  function closePopup() {
    document.getElementById('form-popup').style.display = 'none';
    document.body.style.overflow = '';
  }